import type {
  IdnowProviderDetails,
  KycActiveProcess,
  KycResponse,
} from '@repo/api-kit/queries/due-diligence/kyc';

export function getIdnowProviderDetails(
  kycInfo?: KycResponse | null,
  contextProviderDetails?: { providerDetails: KycActiveProcess['providerDetails'] } | null
): IdnowProviderDetails | null {
  if (kycInfo?.activeProcess?.providerDetails?.$case === 'idnowProviderDetails') {
    return kycInfo.activeProcess.providerDetails.value;
  }
  if (contextProviderDetails?.providerDetails?.$case === 'idnowProviderDetails') {
    return contextProviderDetails.providerDetails.value;
  }
  return null;
}
